
import { IPostCode } from '../../store';
import { addressHelper, IPostCodeSearchResult } from '@homeserve/vue-api-plugin';
import debounce from 'lodash/debounce';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { I18nMixin } from '../../mixins';

@Component
export default class WLPostCode extends Mixins(I18nMixin) {
  @Prop({ type: String, default: 'Votre code postal' })
  public placeholder!: string;

  @State('isEligible', { namespace: 'api/catalog/postCode' })
  private isEligible!: boolean | undefined;

  @Getter('getPostCodeSearchResults', {
    namespace: 'api/address',
  })
  private items!: IPostCodeSearchResult[];

  @Prop()
  private error!: boolean;

  @Prop()
  private value!: IPostCode;

  @Prop()
  private errorMessage!: string;

  private loading = false;

  private search = '';

  private fetchPostCodes = debounce(async function (this: WLPostCode, val) {
    this.loading = true;
    const results = await addressHelper.fetchPostCodeSearchResults(this.$store, {
      country: 'FR',
      input: val,
    });
    if (!results.result || results.result.length === 0) {
      await addressHelper.setPostCodeSearchResults(this.$store, [{ postCode: val, summary: val, town: '' }]);
    }
    this.loading = false;
  }, 300);

  private rules = {
    min: (v: string) => {
      if (!this.error || v.length >= 5) {
        return true;
      }
      return this.translations.error_invalid_postcode;
    },
    isEligible: () => {
      if (typeof this.isEligible === 'boolean' && !this.isEligible) {
        return this.translations.error_not_covered_postcode;
      }

      return true;
    },
  };

  @Watch('search')
  public watchSearch(val: string) {
    if (
      val &&
      val.length >= 5 &&
      this.value.postCode &&
      val.substr(0, 5) === this.value.postCode.substr(0, 5) &&
      this.value.postCode.length
    ) {
      this.$emit('input', this.value);
    } else {
      this.$emit('input', { postCode: this.search, summary: '', town: '' });
    }

    if (this.search && this.search.length > 2 && this.search.length < 7) {
      if (
        !this.value ||
        !this.value.summary ||
        (this.value && this.value.summary && this.value.summary !== this.search)
      ) {
        this.fetchPostCodes(this.search);
      }
    } else if (!this.search || this.search.length < 3) {
      addressHelper.resetPostCodeSearchResults(this.$store);
    }
  }

  created() {
    this.defaultI18n = {
      postcode_question: this.$t('components_plugin.diagnosis.postcode_question'),
      error_invalid_postcode: this.$t('components_plugin.diagnosis.error_invalid_postcode'),
      error_not_covered_postcode: this.$t('components_plugin.diagnosis.error_not_covered_postcode'),
    };
  }
}
